import { render, staticRenderFns } from "./FootprintBungeFabrica.vue?vue&type=template&id=b913dca4&lang=pug"
import script from "./FootprintBungeFabrica.vue?vue&type=script&lang=js"
export * from "./FootprintBungeFabrica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports